import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { QuoteFormData } from "../types/quote";

const getFirebaseFunctionUrl = (): string => {
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
  const region = "us-central1"; // Default region, can be configured
  return `https://${region}-${projectId}.cloudfunctions.net/submitQuote`;
};

export const submitQuote = async (
  quoteData: QuoteFormData,
  corporateOrganization?: string
): Promise<{ success: boolean; id?: string; error?: string }> => {
  try {
    const functionUrl = getFirebaseFunctionUrl();
    const response = await fetch(functionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...quoteData, corporateOrganization }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: "Unknown error" }));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return {
      success: true,
      id: result.id,
    };
  } catch (error: any) {
    console.error("Error submitting quote:", error);
    return {
      success: false,
      error: error.message || "Failed to submit quote",
    };
  }
};

export const getQuoteEmailRecipient = async (): Promise<string> => {
  try {
    const configDoc = await getDoc(doc(db, "config", "quoteSettings"));
    if (configDoc.exists()) {
      const data = configDoc.data();
      return data.recipientEmail || import.meta.env.VITE_QUOTE_EMAIL_RECIPIENT || "";
    }
    return import.meta.env.VITE_QUOTE_EMAIL_RECIPIENT || "";
  } catch (error) {
    console.error("Error fetching email recipient:", error);
    return import.meta.env.VITE_QUOTE_EMAIL_RECIPIENT || "";
  }
};

